<template>
  <svg
    id="hexagon-shape"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="-10 -10 960 750">
    <defs>
      <clipPath id="hex-clippath">
        <path
          d="M344.5,494.8c-1.55,.89-2.5,2.54-2.5,4.33v118.72c0,1.79,.95,3.44,2.5,4.33l103,59.38c1.55,.89,3.45,.89,4.99,0l103-59.38c1.55-.89,2.5-2.54,2.5-4.33v-118.72c0-1.79-.95-3.44-2.5-4.33l-103-59.36c-1.55-.89-3.45-.89-4.99,0l-103,59.36Z"
          style="fill: none" />
      </clipPath>
      <radialGradient
        id="hex-radial-gradient"
        cx="61.72"
        cy="764.49"
        fx="61.72"
        fy="764.49"
        r="1"
        gradientTransform="translate(-35481 -2218) rotate(90) scale(47 -47)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#00d9ea"
          stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="hex-radial-gradient-2"
        cx="62.03"
        cy="763.85"
        fx="62.03"
        fy="763.85"
        r="1"
        gradientTransform="translate(-24757 -1364) rotate(90) scale(33 -33)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#00d9ea"
          stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="hex-linear-gradient"
        x1="423"
        y1="48.5"
        x2="478"
        y2="48.5"
        gradientTransform="translate(0 732) scale(1 -1)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#1d78da" />
        <stop
          offset=".48"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#ffef00" />
      </linearGradient>
      <clipPath id="hex-clippath-1">
        <path
          d="M457.5,297.8c-1.55,.89-2.5,2.54-2.5,4.33v118.72c0,1.79,.95,3.44,2.5,4.33l103,59.38c1.54,.89,3.45,.89,4.99,0l103-59.38c1.55-.89,2.5-2.54,2.5-4.33v-118.72c0-1.79-.95-3.44-2.5-4.33l-103-59.36c-1.55-.89-3.45-.89-4.99,0l-103,59.36Z"
          style="fill: none" />
      </clipPath>
      <radialGradient
        id="hex-radial-gradient-3"
        cx="61.72"
        cy="764.49"
        fx="61.72"
        fy="764.49"
        r="1"
        gradientTransform="translate(-35261 -2480) rotate(90) scale(47 -47)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#00d9ea"
          stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="hex-radial-gradient-4"
        cx="62.03"
        cy="763.85"
        fx="62.03"
        fy="763.85"
        r="1"
        gradientTransform="translate(-24537 -1626) rotate(90) scale(33 -33)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#00d9ea"
          stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="hex-linear-gradient-2"
        x1="643"
        y1="310.5"
        x2="698"
        y2="310.5"
        gradientTransform="translate(0 732) scale(1 -1)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#1d78da" />
        <stop
          offset=".48"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#ffef00" />
      </linearGradient>
      <clipPath id="hex-clippath-2">
        <path
          d="M230.5,297.8c-1.55,.89-2.5,2.54-2.5,4.33v118.72c0,1.79,.95,3.44,2.5,4.33l103,59.38c1.55,.89,3.45,.89,4.99,0l103-59.38c1.55-.89,2.5-2.54,2.5-4.33v-118.72c0-1.79-.95-3.44-2.5-4.33l-103-59.36c-1.55-.89-3.45-.89-4.99,0l-103,59.36Z"
          style="fill: none" />
      </clipPath>
      <radialGradient
        id="hex-radial-gradient-5"
        cx="61.72"
        cy="764.49"
        fx="61.72"
        fy="764.49"
        r="1"
        gradientTransform="translate(-35702 -2603) rotate(90) scale(47 -47)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#00d9ea"
          stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="hex-radial-gradient-6"
        cx="62.03"
        cy="763.85"
        fx="62.03"
        fy="763.85"
        r="1"
        gradientTransform="translate(-24978 -1749) rotate(90) scale(33 -33)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#00d9ea"
          stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="hex-linear-gradient-3"
        x1="202"
        y1="433.5"
        x2="257"
        y2="433.5"
        gradientTransform="translate(0 732) scale(1 -1)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#1d78da" />
        <stop
          offset=".48"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#ffef00" />
      </linearGradient>
      <clipPath id="hex-clippath-3">
        <path
          d="M345.5,101.8c-1.55,.89-2.5,2.54-2.5,4.33v118.72c0,1.79,.95,3.44,2.5,4.33l103,59.38c1.55,.89,3.45,.89,4.99,0l103-59.38c1.55-.89,2.5-2.54,2.5-4.33V106.13c0-1.79-.95-3.44-2.5-4.33l-103-59.36c-1.55-.89-3.45-.89-4.99,0l-103,59.36Z"
          style="fill: none" />
      </clipPath>
      <radialGradient
        id="hex-radial-gradient-7"
        cx="61.72"
        cy="764.49"
        fx="61.72"
        fy="764.49"
        r="1"
        gradientTransform="translate(-35481 -2854) rotate(90) scale(47 -47)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#00d9ea"
          stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="hex-radial-gradient-8"
        cx="62.03"
        cy="763.85"
        fx="62.03"
        fy="763.85"
        r="1"
        gradientTransform="translate(-24757 -2000) rotate(90) scale(33 -33)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#00d9ea"
          stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="hex-linear-gradient-4"
        x1="423"
        y1="684.5"
        x2="478"
        y2="684.5"
        gradientTransform="translate(0 732) scale(1 -1)"
        gradientUnits="userSpaceOnUse">
        <stop
          offset="0"
          stop-color="#1d78da" />
        <stop
          offset=".48"
          stop-color="#00d9ea" />
        <stop
          offset="1"
          stop-color="#ffef00" />
      </linearGradient>
    </defs>
    <g style="isolation: isolate">
      <g
        id="hex-Layer_1"
        data-name="Layer 1">
        <image
          width="288"
          height="321"
          transform="translate(-36 189)"
          xlink:href="@/assets/img/hex-blur-1.png" />
        <image
          width="288"
          height="321"
          transform="translate(537 5)"
          xlink:href="@/assets/img/hex-blur-1.png" />
        <image
          width="288"
          height="321"
          transform="translate(650 202)"
          xlink:href="@/assets/img/hex-blur-2.png" />
        <image
          width="288"
          height="321"
          transform="translate(76 397)"
          xlink:href="@/assets/img/hex-blur-2.png" />
      </g>
      <g id="hex-Four">
        <g id="hex-BG">
          <g style="clip-path: url(#hex-clippath)">
            <rect
              x="286"
              y="412"
              width="329"
              height="293"
              style="fill: #babbbb" />
            <image
              width="600"
              height="514"
              transform="translate(281.74 397.26) scale(.56)"
              :xlink:href="data.four.bg_image.url" />
          </g>
          <g
            class="active-selector"
            :class="activeHex === 'four' ? 'active' : ''"
            transform="translate(337,428)">
            <path
              fill="none"
              d="M0.5 68.1289C0.5 66.5212 1.35768 65.0357 2.74996 64.2318L110.75 1.87645C112.142 1.07257 113.858 1.07257 115.25 1.87645L223.25 64.2318C224.642 65.0357 225.5 66.5212 225.5 68.1289L225.5 192.856C225.5 194.463 224.642 195.949 223.25 196.753L115.25 259.123C113.858 259.927 112.142 259.927 110.75 259.123L2.74955 196.753C1.3575 195.949 0.5 194.463 0.5 192.856L0.5 68.1289Z"
              stroke="white" />
          </g>
        </g>
        <text
          id="hex-Text"
          transform="translate(446.48 588.22)"
          class="multiline"
          data-width="170"
          text-anchor="middle"
          style="fill: #fff; font-family: 'tt-commons-med'; font-size: 22px">
          {{ data.four.title }}
        </text>
        <image
          id="hex-Icon"
          width="61"
          height="61"
          transform="translate(418.53 484.89)"
          :xlink:href="data.four.icon.url" />
        <g
          class="button"
          :class="`${buttonFour ? 'hover' : ''} ${
            activeHex === 'four' ? 'active' : ''
          }`">
          <circle
            cx="450"
            cy="683"
            r="47"
            style="fill: url(#hex-radial-gradient); fill-opacity: 0.5" />
          <circle
            cx="450"
            cy="683"
            r="46.5"
            style="fill: none; stroke: rgba(255, 255, 255, 0.12)" />
          <circle
            cx="450"
            cy="683"
            r="33"
            style="fill: url(#hex-radial-gradient-2); fill-opacity: 0.5" />
          <g
            class="clickable"
            @click="setActive('four')"
            @mouseover="hover('four', true)"
            @mouseout="hover('four', false)">
            <g>
              <circle
                cx="450.5"
                cy="683.5"
                r="27.5"
                style="fill: #fff" />
              <circle
                cx="450.5"
                cy="683.5"
                r="26"
                style="
                  fill: none;
                  stroke: url(#hex-linear-gradient);
                  stroke-width: 3px;
                " />
            </g>
            <path
              d="M449.59,691.07v-6.67h-6.62v-2.79h6.62v-6.62h2.82v6.62h6.62v2.79h-6.62v6.67h-2.82Z"
              style="fill: #232e4f" />
          </g>
        </g>
      </g>
      <g id="hex-Three">
        <g
          id="hex-BG-2"
          data-name="hex-BG">
          <g style="clip-path: url(#hex-clippath-1)">
            <rect
              x="399"
              y="215"
              width="329"
              height="293"
              style="fill: #1d78da" />
            <image
              width="600"
              height="514"
              transform="translate(398 184.48) scale(.65)"
              :xlink:href="data.three.bg_image.url" />
          </g>
          <g
            class="active-selector"
            :class="activeHex === 'three' ? 'active' : ''"
            transform="translate(450,231)">
            <path
              fill="none"
              d="M0.5 68.1289C0.5 66.5212 1.35768 65.0357 2.74996 64.2318L110.75 1.87645C112.142 1.07257 113.858 1.07257 115.25 1.87645L223.25 64.2318C224.642 65.0357 225.5 66.5212 225.5 68.1289L225.5 192.856C225.5 194.463 224.642 195.949 223.25 196.753L115.25 259.123C113.858 259.927 112.142 259.927 110.75 259.123L2.74955 196.753C1.3575 195.949 0.5 194.463 0.5 192.856L0.5 68.1289Z"
              stroke="white" />
          </g>
        </g>
        <text
          id="hex-Text-2"
          data-name="Text"
          transform="translate(562 379.83)"
          class="multiline"
          data-width="120"
          text-anchor="middle"
          style="fill: #fff; font-family: 'tt-commons-med'; font-size: 22px">
          {{ data.three.title }}
        </text>
        <image
          id="hex-Icon-2"
          data-name="Icon"
          width="65"
          height="51"
          transform="translate(531.67 291.83)"
          :xlink:href="data.three.icon.url" />
        <g
          class="button"
          :class="`${buttonThree ? 'hover' : ''} ${
            activeHex === 'three' ? 'active' : ''
          }`">
          <circle
            cx="670"
            cy="421"
            r="47"
            style="fill: url(#hex-radial-gradient-3); fill-opacity: 0.5" />
          <circle
            cx="670"
            cy="421"
            r="46.5"
            style="fill: none; stroke: rgba(255, 255, 255, 0.12)" />
          <circle
            cx="670"
            cy="421"
            r="33"
            style="fill: url(#hex-radial-gradient-4); fill-opacity: 0.5" />
          <g
            class="clickable"
            @click="setActive('three')"
            @mouseover="hover('three', true)"
            @mouseout="hover('three', false)">
            <g>
              <circle
                cx="670.5"
                cy="421.5"
                r="27.5"
                style="fill: #fff" />
              <circle
                cx="670.5"
                cy="421.5"
                r="26"
                style="
                  fill: none;
                  stroke: url(#hex-linear-gradient-2);
                  stroke-width: 3px;
                " />
            </g>
            <path
              d="M669.59,429.07v-6.67h-6.62v-2.79h6.62v-6.62h2.82v6.62h6.62v2.79h-6.62v6.67h-2.82Z"
              style="fill: #232e4f" />
          </g>
        </g>
      </g>
      <g id="hex-Two">
        <g
          id="hex-BG-3"
          data-name="hex-BG">
          <g style="clip-path: url(#hex-clippath-2)">
            <rect
              x="172"
              y="215"
              width="329"
              height="293"
              style="fill: #00d9ea" />
            <image
              width="600"
              height="514"
              transform="translate(168.94 205.77) scale(.55)"
              :xlink:href="data.two.bg_image.url"
              style="mix-blend-mode: multiply; opacity: 0.5" />
          </g>
          <g
            class="active-selector"
            :class="activeHex === 'two' ? 'active' : ''"
            transform="translate(223,231)">
            <path
              fill="none"
              d="M0.5 68.1289C0.5 66.5212 1.35768 65.0357 2.74996 64.2318L110.75 1.87645C112.142 1.07257 113.858 1.07257 115.25 1.87645L223.25 64.2318C224.642 65.0357 225.5 66.5212 225.5 68.1289L225.5 192.856C225.5 194.463 224.642 195.949 223.25 196.753L115.25 259.123C113.858 259.927 112.142 259.927 110.75 259.123L2.74955 196.753C1.3575 195.949 0.5 194.463 0.5 192.856L0.5 68.1289Z"
              stroke="white" />
          </g>
        </g>
        <text
          id="hex-Text-3"
          data-name="Text"
          transform="translate(340 379.83)"
          class="multiline"
          data-width="120"
          text-anchor="middle"
          style="
            fill: #fff;
            font-family: 'tt-commons-med';
            font-size: 22px;
            max-width: 60px;
          ">
          {{ data.two.title }}
        </text>
        <image
          id="hex-Icon-3"
          data-name="Icon"
          width="97"
          height="51"
          transform="translate(287.03 299.5)"
          :xlink:href="data.two.icon.url" />
        <g
          class="button"
          :class="`${buttonTwo ? 'hover' : ''} ${
            activeHex === 'two' ? 'active' : ''
          }`">
          <circle
            cx="229"
            cy="298"
            r="47"
            style="fill: url(#hex-radial-gradient-5); fill-opacity: 0.5" />
          <circle
            cx="229"
            cy="298"
            r="46.5"
            style="fill: none; stroke: rgba(255, 255, 255, 0.12)" />
          <circle
            cx="229"
            cy="298"
            r="33"
            style="fill: url(#hex-radial-gradient-6); fill-opacity: 0.5" />
          <g
            class="clickable"
            @click="setActive('two')"
            @mouseover="hover('two', true)"
            @mouseout="hover('two', false)">
            >
            <g>
              <circle
                cx="229.5"
                cy="298.5"
                r="27.5"
                style="fill: #fff" />
              <circle
                cx="229.5"
                cy="298.5"
                r="26"
                style="
                  fill: none;
                  stroke: url(#hex-linear-gradient-3);
                  stroke-width: 3px;
                " />
            </g>
            <path
              d="M228.59,306.07v-6.67h-6.62v-2.79h6.62v-6.62h2.82v6.62h6.62v2.79h-6.62v6.67h-2.82Z"
              style="fill: #232e4f" />
          </g>
        </g>
      </g>
      <g id="hex-One">
        <g
          id="hex-BG-4"
          data-name="hex-BG">
          <g style="clip-path: url(#hex-clippath-3)">
            <rect
              x="287"
              y="19"
              width="329"
              height="293"
              style="fill: #ffef00" />
            <image
              width="599"
              height="514"
              transform="translate(296.37 34.79) scale(.52)"
              :xlink:href="data.one.bg_image.url"
              style="mix-blend-mode: multiply; opacity: 0.5" />
          </g>
          <g
            class="active-selector"
            :class="activeHex === 'one' ? 'active' : ''"
            transform="translate(338,35)">
            <path
              stroke="white"
              fill="none"
              d="M0.5 68.1289C0.5 66.5212 1.35768 65.0357 2.74996 64.2318L110.75 1.87645C112.142 1.07257 113.858 1.07257 115.25 1.87645L223.25 64.2318C224.642 65.0357 225.5 66.5212 225.5 68.1289L225.5 192.856C225.5 194.463 224.642 195.949 223.25 196.753L115.25 259.123C113.858 259.927 112.142 259.927 110.75 259.123L2.74955 196.753C1.3575 195.949 0.5 194.463 0.5 192.856L0.5 68.1289Z" />
          </g>
        </g>
        <text
          id="hex-Text-4"
          data-name="Text"
          transform="translate(450.57 207.98)"
          class="multiline"
          data-width="120"
          text-anchor="middle"
          style="fill: #fff; font-family: 'tt-commons-med'; font-size: 22px">
          {{ data.one.title }}
        </text>
        <image
          id="hex-Icon-4"
          data-name="Icon"
          width="34"
          height="67"
          transform="translate(434.44 102.56)"
          :xlink:href="data.one.icon.url" />
        <g
          class="button"
          :class="`${buttonOne ? 'hover' : ''} ${
            activeHex === 'one' ? 'active' : ''
          }`"
          data-name="Button">
          <circle
            cx="450"
            cy="47"
            r="47"
            style="fill: url(#hex-radial-gradient-7); fill-opacity: 0.5" />
          <circle
            cx="450"
            cy="47"
            r="46.5"
            style="fill: none; stroke: rgba(255, 255, 255, 0.12)" />
          <circle
            cx="450"
            cy="47"
            r="33"
            style="fill: url(#hex-radial-gradient-8); fill-opacity: 0.5" />
          <g
            class="clickable"
            @click="setActive('one')"
            @mouseover="hover('one', true)"
            @mouseout="hover('one', false)">
            <g>
              <circle
                cx="450.5"
                cy="47.5"
                r="27.5"
                style="fill: #fff" />
              <circle
                cx="450.5"
                cy="47.5"
                r="26"
                style="
                  fill: none;
                  stroke: url(#hex-linear-gradient-4);
                  stroke-width: 3px;
                " />
            </g>
            <path
              d="M449.59,55.07v-6.67h-6.62v-2.79h6.62v-6.62h2.82v6.62h6.62v2.79h-6.62v6.67h-2.82Z"
              style="fill: #232e4f" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script setup>
import { onMounted, onBeforeUnmount, ref, watch } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['activeHex'])

const buttonOne = ref(false)
const buttonTwo = ref(false)
const buttonThree = ref(false)
const buttonFour = ref(false)
const activeHex = ref('')

watch(
  () => props.data.config,
  (newVal) => {
    activeHex.value = newVal.activeHex
  }
)

const setActive = (value) => {
  emit('activeHex', value)
}

const hover = (state, value) => {
  if (state === 'one') {
    buttonOne.value = value
  } else if (state === 'two') {
    buttonTwo.value = value
  } else if (state === 'three') {
    buttonThree.value = value
  } else if (state === 'four') {
    buttonFour.value = value
  }
}

const handleMultiLine = () => {
  var textBoxes = document.getElementsByClassName('multiline')
  for (var i = 0; i < textBoxes.length; i++) {
    createMultiline(textBoxes[i])
  }

  function createMultiline(textElement) {
    var words = textElement.firstChild.data.split(' ')
    var width = parseFloat(textElement.getAttributeNS(null, 'data-width'))

    // Clear original text
    textElement.firstChild.data = ''

    // Create first tspan element
    var tspanElement = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'tspan'
    )

    // Create text in tspan element
    var textNode = document.createTextNode(words[0])

    // Add tspan element to DOM
    tspanElement.appendChild(textNode)

    // Add text to tspan element
    textElement.appendChild(tspanElement)

    for (var i = 1; i < words.length; i++) {
      var len = textNode.data.length

      // Add next word
      tspanElement.firstChild.data += ' ' + words[i]

      if (tspanElement.getComputedTextLength() > width) {
        // Remove added word
        tspanElement.firstChild.data = tspanElement.firstChild.data.slice(
          0,
          len
        )

        // Create new tspan element
        tspanElement = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'tspan'
        )
        tspanElement.setAttributeNS(null, 'x', 0)
        tspanElement.setAttributeNS(null, 'dy', 24)

        textNode = document.createTextNode(words[i])
        tspanElement.appendChild(textNode)
        textElement.appendChild(tspanElement)
      }
    }
  }
}

const initialAnimation = () => {
  gsap.fromTo(
    [
      '#hexagon-shape #hex-One',
      '#hexagon-shape #hex-Two',
      '#hexagon-shape #hex-Three',
      '#hexagon-shape #hex-Four',
    ],
    {
      opacity: 0,
      y: 100,
    },
    {
      opacity: 1,
      y: 0,
      duration: 1,
      stagger: 0.2,
      ease: 'power4.inOut',
      scrollTrigger: {
        id: 'hexagon-shape',
        trigger: '#hexagon-shape',
        start: 'top center-=10%',
        markers: false,
      },
    }
  )
}

onMounted(() => {
  handleMultiLine()
  initialAnimation()
})

onBeforeUnmount(() => {
  const scrollAnim = ScrollTrigger.getById('hexagon-shape')
  if (scrollAnim) scrollAnim.kill()
})
</script>
<style lang="scss" scoped>
.button {
  @apply transition-all duration-300 ease-in-out transform-gpu;
  transform: rotate(0) scale(1);
  transform-box: fill-box;
  transform-origin: center;
  &.hover {
    transform: rotate(90deg) scale(1.2);
  }
  &.active {
    opacity: 0;
  }
  .clickable {
    @apply cursor-pointer;
  }
}

.active-selector {
  @apply transition-all duration-300 ease-in-out;
  opacity: 0;
  &.active {
    opacity: 1;
  }
}
</style>
